(function(angular){
	'use strict';

	angular.module('confirmationModalModule', [
		'BaseConfig'
	]);

})(window.angular);